import * as ActionButtonWidget from './../../widgets/ActionButtonWidget'
import {findActionsWithActionId} from "../../common/Metadata";
import {isFeatureEnabled} from "../../login/ClientCache";
import {userCanAction} from "../../login/Security";
import ActionBlockTemplate from "../../compiled-templates/ActionBlockTemplate";

export class EditActionBlock {
    constructor(block, metaData, presenter) {
        this.hasActions = false;
        this.metaData = metaData;
        this.presenter = presenter;
        this._collectActionButtons(block);
    }

    /**
     *
     * @param {namaTypes.EditScreenActionsBlock} block
     * @param {ExtendedNamaMetadata} metaData
     */
    _collectActionButtons(block) {
        this._actionButtons = [];
        for (let action of block.actions) {
            let guiActionInfo = findActionsWithActionId(action.id, this.metaData);
            if (action.customization.empty) {
                if (!guiActionInfo)
                    continue;
                if (!isFeatureEnabled(guiActionInfo.relatedtoFeature))
                    continue;
                if (!userCanAction(this.metaData.owner.ownerId, action.id))
                    continue;
            } else if (action.customization.securityID) {
                if (!userCanAction(this.metaData.owner.ownerId, action.customization.securityID))
                    continue;
            }
            this._actionButtons.push(action);
            this.hasActions = true;
        }
    }


    render(entityType) {
        let blockContainer = $(ActionBlockTemplate());
        for (let action of this._actionButtons) {
            new ActionButtonWidget.ActionButtonWidget(entityType, action.id, action.title, action.customization).render(this.metaData, this.presenter, blockContainer);
        }
        return blockContainer;
    }
}